import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';
import { Component, createRef, Fragment } from '@wordpress/element';
import { TabPanel, Button } from '@wordpress/components';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
/**
 * Internal dependencies
 */

import ComparePeriods from './compare-periods';
import DateRange from '../calendar/date-range';
import { H, Section } from '../section';
import PresetPeriods from './preset-periods';

var DatePickerContent =
/*#__PURE__*/
function (_Component) {
  _inherits(DatePickerContent, _Component);

  function DatePickerContent() {
    var _this;

    _classCallCheck(this, DatePickerContent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatePickerContent).call(this));
    _this.onTabSelect = _this.onTabSelect.bind(_assertThisInitialized(_this));
    _this.controlsRef = createRef();
    return _this;
  }

  _createClass(DatePickerContent, [{
    key: "onTabSelect",
    value: function onTabSelect(tab) {
      var _this$props = this.props,
          onUpdate = _this$props.onUpdate,
          period = _this$props.period;
      /**
       * If the period is `custom` and the user switches tabs to view the presets,
       * then a preset should be selected. This logic selects the default, otherwise
       * `custom` value for period will result in no selection.
       */

      if ('period' === tab && 'custom' === period) {
        onUpdate({
          period: 'today'
        });
      }
    }
  }, {
    key: "isFutureDate",
    value: function isFutureDate(dateString) {
      return moment().isBefore(moment(dateString), 'day');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          period = _this$props2.period,
          compare = _this$props2.compare,
          after = _this$props2.after,
          before = _this$props2.before,
          onUpdate = _this$props2.onUpdate,
          onClose = _this$props2.onClose,
          onSelect = _this$props2.onSelect,
          isValidSelection = _this$props2.isValidSelection,
          resetCustomValues = _this$props2.resetCustomValues,
          focusedInput = _this$props2.focusedInput,
          afterText = _this$props2.afterText,
          beforeText = _this$props2.beforeText,
          afterError = _this$props2.afterError,
          beforeError = _this$props2.beforeError,
          shortDateFormat = _this$props2.shortDateFormat;
      return createElement("div", null, createElement(H, {
        className: "screen-reader-text",
        tabIndex: "0"
      }, __('Select date range and comparison', 'woocommerce-admin')), createElement(Section, {
        component: false
      }, createElement(H, {
        className: "woocommerce-filters-date__text"
      }, __('select a date range', 'woocommerce-admin')), createElement(TabPanel, {
        tabs: [{
          name: 'period',
          title: __('Presets', 'woocommerce-admin'),
          className: 'woocommerce-filters-date__tab'
        }, {
          name: 'custom',
          title: __('Custom', 'woocommerce-admin'),
          className: 'woocommerce-filters-date__tab'
        }],
        className: "woocommerce-filters-date__tabs",
        activeClass: "is-active",
        initialTabName: 'custom' === period ? 'custom' : 'period',
        onSelect: this.onTabSelect
      }, function (selected) {
        return createElement(Fragment, null, selected.name === 'period' && createElement(PresetPeriods, {
          onSelect: onUpdate,
          period: period
        }), selected.name === 'custom' && createElement(DateRange, {
          after: after,
          before: before,
          onUpdate: onUpdate,
          isInvalidDate: _this2.isFutureDate,
          focusedInput: focusedInput,
          afterText: afterText,
          beforeText: beforeText,
          afterError: afterError,
          beforeError: beforeError,
          shortDateFormat: shortDateFormat,
          losesFocusTo: _this2.controlsRef.current
        }), createElement("div", {
          className: classnames('woocommerce-filters-date__content-controls', {
            'is-custom': selected.name === 'custom'
          }),
          ref: _this2.controlsRef
        }, createElement(H, {
          className: "woocommerce-filters-date__text"
        }, __('compare to', 'woocommerce-admin')), createElement(ComparePeriods, {
          onSelect: onUpdate,
          compare: compare
        }), createElement("div", {
          className: "woocommerce-filters-date__button-group"
        }, selected.name === 'custom' && createElement(Button, {
          className: "woocommerce-filters-date__button",
          isDefault: true,
          onClick: resetCustomValues,
          disabled: !(after || before)
        }, __('Reset', 'woocommerce-admin')), isValidSelection(selected.name) ? createElement(Button, {
          className: "woocommerce-filters-date__button",
          onClick: onSelect(selected.name, onClose),
          isPrimary: true
        }, __('Update', 'woocommerce-admin')) : createElement(Button, {
          className: "woocommerce-filters-date__button",
          isPrimary: true,
          disabled: true
        }, __('Update', 'woocommerce-admin')))));
      })));
    }
  }]);

  return DatePickerContent;
}(Component);

DatePickerContent.propTypes = {
  period: PropTypes.string.isRequired,
  compare: PropTypes.string.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  resetCustomValues: PropTypes.func.isRequired,
  focusedInput: PropTypes.string,
  afterText: PropTypes.string,
  beforeText: PropTypes.string,
  afterError: PropTypes.string,
  beforeError: PropTypes.string,
  shortDateFormat: PropTypes.string.isRequired
};
export default DatePickerContent;
//# sourceMappingURL=content.js.map